import React, {useState} from 'react';
import TogglerBody from '../TogglerBody';
import FlagCustomisationItemCounter from './FlagCustomisationItemCounter';
import FlagCustomisationItemInputs from './FlagCustomisationItemInputs';
import './flagCustomisation.scss';

const flagItemArr = [
  {
    title: 'Advertisement',
    targetTogler: 'Target ads related accounts',
    counter: [],
    targetSlader: '',
    currentAction: 'Log',
    chooseActionTarget: 'Punishment',
    trigger: 'advertisementTrigger',
    keyName: 'advertisementPunishment',
  },
  {
    title: 'Account Age',
    targetTogler: 'Target profiles younger that a specified timeframe',
    counter: [
      {
        title: 'Minimum Age',
        target: '',
        time: 'day',
        keyName: 'minimumAge',
        keyTime: 'minimumAgePer',
      },
    ],
    targetSlader: '',
    currentAction: '',
    chooseActionTarget: 'Punishment',
    tipsTitle: 'Account Age',
    label: 'Unsafe',
    text: '<p>Account Age option empowers Themis to punish users with accounts younger than the specified duration.</p>',
    textSecond: '',
    trigger: 'accountAgeTrigger',
    keyName: 'minimumAgePunishment',
  },
  {
    title: 'No Avatar',
    targetTogler: 'Target accounts without profile picutre',
    counter: [],
    // targetSlader: 'Sensitivity',
    currentAction: 'Warn',
    chooseActionTarget: 'Punishment',
    trigger: 'noAvatarTrigger',
    keyName: 'noAvatarPunishment',
  },
];

const flagItemArr2 = [
  {
    title: 'Name Similarity',
    targetTogler: 'Target accounts with similar usernames',
    counter: [],
    targetSlader: 'Sensitivity',
    currentAction: 'Ban',
    chooseActionTarget: 'Punishment',
    trigger: 'nameSimilarityTrigger',
    keyName: 'nameSimilarityPunishment',
    sliderKeyName: 'nameSimilaritySensitivity',
  },
  {
    title: 'AI-Based Text',
    targetTogler: 'Target accounts using AI-generated text',
    counter: [],
    targetSlader: 'Sensitivity',
    currentAction: 'Ban',
    chooseActionTarget: 'Punishment',
    trigger: 'aiTextTrigger',
    keyName: 'aiTextPunishment',
    sliderKeyName: 'aiTextSensitivity',
  },
  {
    title: 'Cross-server behaviour',
    targetTogler: 'Target accounts that previously was punished',
    counter: [],
    targetSlader: '',
    currentAction: '',
    chooseActionTarget: 'Punishment',
    trigger: 'crossServerTrigger',
    keyName: 'crossServerPunishment',
  },
];
const flagItemArrInputs = [
  {
    title: 'Blacklist Names',
    targetTogler: 'Target local dictionary',
    counter: [],
    targetSlader: '',
    currentAction: 'Ban',
    chooseActionTarget: 'Punishment',
    trigger: 'blacklist',
    keyName: 'blacklistPunishment',
    strictWords: 'strictWords',
    wildcardWords: 'wildcardWords',
  },
];

const FlagCustomisationFakeDetection = ({title, text, data}) => {
  const [isCustommisation, setIsCustommisation] = useState(data?.enabled);

  return (
    <div className="advance_seting_with_title_wrap">
      {!!title && (
        <div className="overview_component_content_head">
          <h4>{title}</h4>
          <p>{text}</p>
        </div>
      )}
      <div className="status_block_wrap flag_customisation_wrap">
        <div className="status_block_wrap_bg"></div>
        <img className="status_block_wrap_img" src="/img/FlagSettings.svg" alt="" />
        <h3>Flag Customisation</h3>
        <div className="status_block_item" style={{borderBottom: '1px solid #8D99A3'}}>
          <div className="status_block_item_toggler">
            <TogglerBody
              isOn={isCustommisation}
              setIsOn={setIsCustommisation}
              keyName={'enabled'}
              advance
            />
            <p>Use advanced parameters</p>
          </div>
        </div>
        <div className="status_block_item flag_customisation_wrap_block_plug">
          <div
            className={`status_block_item flag_customisation_wrap_block ${
              isCustommisation ? '' : 'flag_customisation_wrap_block_blur'
            }`}>
            <div className="flag_customisation_wrap_block_item_one">
              {flagItemArrInputs.map((item, idx) => (
                <FlagCustomisationItemInputs key={idx} item={item} data={data} />
              ))}
            </div>
            <div className="flag_customisation_wrap_block_item_two">
              {flagItemArr.map((item, idx) => (
                <FlagCustomisationItemCounter key={idx} item={item} data={data} />
              ))}
            </div>
          </div>
          <div
            className={`status_block_item flag_customisation_wrap_block ${
              isCustommisation ? '' : 'flag_customisation_wrap_block_blur'
            }`}>
            {flagItemArr2.map((item, idx) => (
              <FlagCustomisationItemCounter key={idx} item={item} data={data} />
            ))}
          </div>
          {!isCustommisation && (
            <div className="flag_customisation_wrap_plug">
              <p>Enable Advanced Parameters 🙏🏻</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default FlagCustomisationFakeDetection;
